import { Suspense, lazy } from "react";
import { Route, Routes, useLocation, useMatch } from "react-router-dom";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";
import { PushAskSheet } from "./components/PushAsk";
import { SignInSheet } from "./components/SignIn";
import { TabBar } from "./components/TabBar";
import { TermSheet } from "./components/TermSheet";
import { useSession } from "./lib/session";
import { Today } from "./screens/Today";

// Secondary screens ship as separate chunks so the first paint only pays for Today.
const Following = lazy(() =>
  import("./screens/Following").then((m) => ({ default: m.Following })),
);
const Privacy = lazy(() => import("./screens/Privacy").then((m) => ({ default: m.Privacy })));
const Search = lazy(() => import("./screens/Search").then((m) => ({ default: m.Search })));
const StoryView = lazy(() =>
  import("./screens/StoryView").then((m) => ({ default: m.StoryView })),
);
const Terms = lazy(() => import("./screens/Terms").then((m) => ({ default: m.Terms })));
const You = lazy(() => import("./screens/You").then((m) => ({ default: m.You })));

export function App() {
  const { message } = useSession();
  const inStory = Boolean(useMatch("/stories/:id"));
  const location = useLocation();
  return (
    <>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/stories/:id" element={<StoryView />} />
          <Route
            path="*"
            element={
              <AnimatePresence mode="wait" initial={false}>
                <m.main
                  key={location.pathname}
                  className="app"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -8 }}
                  transition={{ duration: 0.18, ease: "easeOut" }}
                >
                  <Routes location={location}>
                    <Route index element={<Today />} />
                    <Route path="search" element={<Search />} />
                    <Route path="terms" element={<Terms />} />
                    <Route path="following" element={<Following />} />
                    <Route path="you" element={<You />} />
                    <Route path="privacy" element={<Privacy />} />
                    <Route path="*" element={<p className="empty">That page does not exist.</p>} />
                  </Routes>
                </m.main>
              </AnimatePresence>
            }
          />
        </Routes>
      </Suspense>
      {!inStory && <TabBar />}
      <TermSheet />
      <SignInSheet />
      <PushAskSheet />
      {message && (
        <div className="toast" role="status">
          {message}
        </div>
      )}
    </>
  );
}
